<div class="ref-dataset-detail">
  <app-header [forceLightBackground]="true"></app-header>

  <div class="ref-dataset-detail__content">
    <app-asset-header
      [config]="headerConfig"
      variant="tanuh"
      [showActions]="false"
    ></app-asset-header>

    <div class="ref-dataset-detail__main" *ngIf="isLoading" aria-busy="true" aria-label="Loading dataset details">
      <div class="ref-dataset-detail__container">
        <div class="ref-dataset-detail__skeleton">
          <div class="ref-dataset-detail__skeleton-row">
            <div class="ref-dataset-detail__skeleton-col">
              <div class="ref-dataset-detail__skeleton-attrs">
                <div class="ref-skel ref-skel--attr" *ngFor="let i of [1, 2, 3]"></div>
              </div>
              <div class="ref-skel ref-skel--title"></div>
              <div class="ref-skel ref-skel--line" *ngFor="let n of [1, 2, 3, 4, 5]"></div>
              <div class="ref-skel ref-skel--block"></div>
            </div>
            <div class="ref-dataset-detail__skeleton-aside">
              <div class="ref-skel ref-skel--card"></div>
              <div class="ref-skel ref-skel--card ref-skel--card-short"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ref-dataset-detail__main" *ngIf="!isLoading && loadError">
      <div class="ref-dataset-detail__container">
        <p class="ref-dataset-detail__error">{{ loadError }}</p>
        <button type="button" class="ref-dataset-detail__back-btn" (click)="goBack()">Back to datasets</button>
      </div>
    </div>

    <div class="ref-dataset-detail__main" *ngIf="!isLoading && dataset && !loadError">
      <div class="ref-dataset-detail__container">
        <div class="ref-dataset-detail__row">
          <!-- Left: overview + metrics -->
          <div class="ref-dataset-detail__col-left">
            <section class="ref-dataset-detail__attributes" aria-label="Dataset characteristics">
              <div
                class="ref-dataset-detail__attribute ref-dataset-detail__attribute--problem"
                [class.ref-dataset-detail__attribute--multiclass]="problemStatementKind === 'multiclass'"
                [class.ref-dataset-detail__attribute--segmentation]="problemStatementKind === 'segmentation'"
                [class.ref-dataset-detail__attribute--bounding-box]="problemStatementKind === 'boundingBox'"
                *ngIf="dataset.problemStatement"
              >
                <svg class="ref-dataset-detail__attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <ng-container [ngSwitch]="problemStatementKind">
                    <ng-container *ngSwitchCase="'multiclass'">
                      <circle cx="12" cy="7" r="3" stroke="currentColor" stroke-width="2"/>
                      <circle cx="6" cy="17" r="3" stroke="currentColor" stroke-width="2"/>
                      <circle cx="18" cy="17" r="3" stroke="currentColor" stroke-width="2"/>
                    </ng-container>
                    <ng-container *ngSwitchCase="'segmentation'">
                      <path d="M3 9h18" stroke="currentColor" stroke-width="2"/>
                      <path d="M3 15h18" stroke="currentColor" stroke-width="2"/>
                      <path d="M9 3v18" stroke="currentColor" stroke-width="2"/>
                      <path d="M15 3v18" stroke="currentColor" stroke-width="2"/>
                    </ng-container>
                    <ng-container *ngSwitchCase="'boundingBox'">
                      <rect x="4" y="6" width="16" height="12" rx="1" stroke="currentColor" stroke-width="2" stroke-dasharray="3 3"/>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                      <circle cx="12" cy="12" r="6" stroke="currentColor" stroke-width="2"/>
                      <circle cx="12" cy="12" r="2" stroke="currentColor" stroke-width="2"/>
                    </ng-container>
                  </ng-container>
                </svg>
                <div>
                  <div class="ref-dataset-detail__attribute-label">Problem statement</div>
                  <div class="ref-dataset-detail__attribute-value">{{ dataset.problemStatement }}</div>
                </div>
              </div>
              <div class="ref-dataset-detail__attribute">
                <svg class="ref-dataset-detail__attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                  <path d="M21 15l-5-5L5 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div>
                  <div class="ref-dataset-detail__attribute-label">Modality</div>
                  <div class="ref-dataset-detail__attribute-value">{{ dataset.modality }}</div>
                </div>
              </div>
              <div class="ref-dataset-detail__attribute">
                <svg class="ref-dataset-detail__attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="2"/>
                  <polyline points="14 2 14 8 20 8" stroke="currentColor" stroke-width="2"/>
                </svg>
                <div>
                  <div class="ref-dataset-detail__attribute-label">Volume</div>
                  <div class="ref-dataset-detail__attribute-value">{{ dataset.volume }}</div>
                </div>
              </div>
              <div
                class="ref-dataset-detail__attribute"
                [class.ref-dataset-detail__attribute--clickable]="hasBreastDensityGuide"
                [attr.role]="hasBreastDensityGuide ? 'button' : null"
                [attr.tabindex]="hasBreastDensityGuide ? 0 : null"
                [attr.aria-label]="hasBreastDensityGuide ? 'View breast density class examples' : null"
                (click)="hasBreastDensityGuide && openDensityModal()"
                (keydown.enter)="hasBreastDensityGuide && openDensityModal()"
                (keydown.space)="hasBreastDensityGuide && openDensityModal(); $event.preventDefault()"
              >
                <svg class="ref-dataset-detail__attribute-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div>
                  <div class="ref-dataset-detail__attribute-label">Output</div>
                  <div
                    class="ref-dataset-detail__attribute-value"
                    [class.ref-dataset-detail__attribute-value--link]="hasBreastDensityGuide"
                  >
                    {{ dataset.output }}
                  </div>
                </div>
              </div>
            </section>

            <section class="ref-dataset-detail__metrics-section" id="evaluation-metrics">
              <div class="ref-dataset-detail__metrics-header">
                <h2 class="ref-dataset-detail__metrics-title">Evaluation Metrics</h2>
                <p class="ref-dataset-detail__metrics-subtitle">
                  Metrics reported when your model is evaluated against this benchmarking dataset.
                </p>
              </div>

              <div class="ref-dataset-detail__metrics-grid">
                <div
                  *ngFor="let metric of evaluationMetrics"
                  class="ref-dataset-detail__metric-card"
                  [class.ref-dataset-detail__metric-card--primary]="metric.isPrimary"
                  [class.ref-dataset-detail__metric-card--secondary]="metric.isSecondary"
                >
                  <div class="ref-dataset-detail__metric-info">
                    <span class="ref-dataset-detail__metric-name">{{ metric.label }}</span>
                    <span
                      *ngIf="formatMetricRange(metric) as metricRange"
                      class="ref-dataset-detail__metric-range"
                    >{{ metricRange }}</span>
                  </div>
                  <span
                    *ngIf="metric.isPrimary"
                    class="ref-dataset-detail__metric-badge ref-dataset-detail__metric-badge--primary"
                  >Primary</span>
                  <span
                    *ngIf="metric.isSecondary"
                    class="ref-dataset-detail__metric-badge ref-dataset-detail__metric-badge--secondary"
                  >Secondary</span>
                </div>
              </div>
            </section>

            <section
              *ngIf="publicProfile && hasDatasetStatistics"
              class="ref-dataset-detail__public-section"
              aria-label="Dataset statistics"
            >
              <div class="ref-dataset-detail__public-header">
                <h2 class="ref-dataset-detail__public-title">Dataset Statistics</h2>
                <p class="ref-dataset-detail__public-subtitle" *ngIf="publicProfile.participantCount && publicProfile.imageCount">
                  {{ publicProfile.participantCount | number }} participants ·
                  {{ publicProfile.imageCount | number }} images
                </p>
                <p
                  class="ref-dataset-detail__public-subtitle"
                  *ngIf="publicProfile.participantCount && !publicProfile.imageCount"
                >
                  {{ publicProfile.participantCount | number }} patient records
                </p>
                <p
                  class="ref-dataset-detail__public-subtitle"
                  *ngIf="!publicProfile.participantCount"
                >
                  {{ publicProfile.totalSamples | number }} labelled samples in the reference set.
                </p>
              </div>
              <dl
                *ngIf="publicProfile.summaryStats?.length"
                class="ref-dataset-detail__summary-stats"
              >
                <div
                  class="ref-dataset-detail__summary-stat"
                  *ngFor="let stat of publicProfile.summaryStats"
                >
                  <dt>{{ stat.label }}</dt>
                  <dd>{{ stat.value }}</dd>
                </div>
              </dl>
              <div
                *ngIf="publicProfile.distributions?.length"
                class="ref-dataset-detail__distributions"
              >
                <app-reference-dataset-distribution-chart
                  *ngFor="let distribution of publicProfile.distributions"
                  [distribution]="distribution"
                ></app-reference-dataset-distribution-chart>
              </div>
              <p
                *ngIf="(publicProfile.distributions?.length ?? 0) > 1"
                class="ref-dataset-detail__distribution-total"
              >
                Overall total: {{ publicProfile.totalSamples | number }}
              </p>
            </section>

            <section
              *ngIf="publicProfile && hasInputOutputSections"
              class="ref-dataset-detail__public-section"
              aria-label="Input and output"
            >
              <div class="ref-dataset-detail__io-grid">
                <div class="ref-dataset-detail__io-card" *ngIf="hasInputProfile">
                  <h3 class="ref-dataset-detail__io-title">Input</h3>
                  <dl class="ref-dataset-detail__io-list">
                    <div class="ref-dataset-detail__io-row" *ngIf="publicProfile.input.dataType">
                      <dt>Data type</dt>
                      <dd>{{ publicProfile.input.dataType }}</dd>
                    </div>
                    <div class="ref-dataset-detail__io-row" *ngIf="publicProfile.input.size">
                      <dt>Size</dt>
                      <dd>{{ publicProfile.input.size }}</dd>
                    </div>
                    <div class="ref-dataset-detail__io-row" *ngIf="publicProfile.input.maxFileSize">
                      <dt>Max file size</dt>
                      <dd>{{ publicProfile.input.maxFileSize }}</dd>
                    </div>
                    <div class="ref-dataset-detail__io-row" *ngIf="publicProfile.input.format">
                      <dt>Format</dt>
                      <dd>{{ publicProfile.input.format }}</dd>
                    </div>
                    <div class="ref-dataset-detail__io-row" *ngIf="publicProfile.input.organization">
                      <dt>Organization</dt>
                      <dd>{{ publicProfile.input.organization }}</dd>
                    </div>
                    <div class="ref-dataset-detail__io-row" *ngIf="publicProfile.input.preprocessing">
                      <dt>Pre-processing</dt>
                      <dd>{{ publicProfile.input.preprocessing }}</dd>
                    </div>
                  </dl>
                </div>
                <div class="ref-dataset-detail__io-card" *ngIf="hasOutputProfile">
                  <h3 class="ref-dataset-detail__io-title">Output</h3>
                  <dl class="ref-dataset-detail__io-list">
                    <div class="ref-dataset-detail__io-row" *ngIf="publicProfile.output.dataType">
                      <dt>Data type</dt>
                      <dd>{{ publicProfile.output.dataType }}</dd>
                    </div>
                    <div class="ref-dataset-detail__io-row" *ngIf="publicProfile.output.format">
                      <dt>Format</dt>
                      <dd>{{ publicProfile.output.format }}</dd>
                    </div>
                    <div class="ref-dataset-detail__io-row" *ngIf="publicProfile.output.maxFileSize">
                      <dt>Max file size</dt>
                      <dd>{{ publicProfile.output.maxFileSize }}</dd>
                    </div>
                    <div
                      class="ref-dataset-detail__io-row"
                      *ngIf="publicProfile.output.columns?.length"
                    >
                      <dt>Columns</dt>
                      <dd class="ref-dataset-detail__detail-mono">
                        {{ publicProfile.output.columns?.join(', ') }}
                      </dd>
                    </div>
                    <div class="ref-dataset-detail__io-row" *ngIf="publicProfile.output.description">
                      <dt>Description</dt>
                      <dd>{{ publicProfile.output.description }}</dd>
                    </div>
                  </dl>
                </div>
              </div>
              <p
                *ngIf="publicProfile.acknowledgments"
                class="ref-dataset-detail__acknowledgments"
              >
                <strong>Acknowledgements.</strong> {{ publicProfile.acknowledgments }}
              </p>
              <p *ngIf="publicProfile.version" class="ref-dataset-detail__version">
                Dataset version: {{ publicProfile.version }}
              </p>
            </section>
          </div>

          <!-- Right: dataset details sidebar -->
          <aside class="ref-dataset-detail__col-right">
            <div class="ref-dataset-detail__sidebar">
              <h3 class="ref-dataset-detail__sidebar-title">Key Metrics</h3>

              <dl class="ref-dataset-detail__details-list">
                <div
                  class="ref-dataset-detail__detail-row"
                  *ngFor="let metric of primaryMetrics; let index = index"
                >
                  <dt>Primary metric {{ primaryMetrics.length > 1 ? (index + 1) : '' }}</dt>
                  <dd>{{ metric }}</dd>
                </div>
                <div class="ref-dataset-detail__detail-row">
                  <dt>Secondary metric</dt>
                  <dd>{{ secondaryMetricLabel }}</dd>
                </div>
              </dl>

              <button type="button" class="ref-dataset-detail__submit-btn" (click)="submitModel()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                  <polyline points="17 8 12 3 7 8"/>
                  <line x1="12" y1="3" x2="12" y2="15"/>
                </svg>
                Submit Model
              </button>
            </div>
          </aside>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>

  <app-modal
    [(visible)]="showDensityModal"
    [width]="'960px'"
    [showHeader]="false"
    [showFooter]="false"
    [styleClass]="'custom-modal breast-density-modal-dialog'"
    (visibleChange)="showDensityModal = $event"
    (onClose)="hoveredDensityClass = null"
  >
    <div class="breast-density-modal-body">
      <button
        type="button"
        class="breast-density-guide__close"
        aria-label="Close breast density guide"
        (click)="showDensityModal = false"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>

      <div class="breast-density-guide">
      <div class="breast-density-guide__images-panel">
        <div class="breast-density-guide__images-grid">
          <figure
            *ngFor="let densityClass of densityGuideGridOrder"
            class="breast-density-guide__image-cell"
            [class.breast-density-guide__image-cell--active]="isDensityGuideHighlighted(densityClass)"
            (mouseenter)="onDensityGuideHover(densityClass)"
            (mouseleave)="onDensityGuideHover(null)"
            (focusin)="onDensityGuideHover(densityClass)"
            (focusout)="onDensityGuideHover(null)"
            tabindex="0"
          >
            <img
              *ngIf="getDensitySample(densityClass) as sample"
              [src]="sample.src"
              [alt]="'Density class ' + sample.class + ' mammogram example'"
              loading="lazy"
            />
          </figure>
        </div>
        <span class="breast-density-guide__hover-hint">Hover for reference</span>
      </div>

      <div class="breast-density-guide__content-panel">
        <div class="breast-density-guide__header">
          <h3 class="breast-density-guide__title">Breast Density Label Guide</h3>
          <p class="breast-density-guide__subtitle">Reference examples use left CC images.</p>
        </div>

        <div class="breast-density-guide__cards">
          <article
            *ngFor="let sample of densitySampleImages"
            class="breast-density-guide__card"
            [class.breast-density-guide__card--active]="isDensityGuideHighlighted(sample.class)"
            (mouseenter)="onDensityGuideHover(sample.class)"
            (mouseleave)="onDensityGuideHover(null)"
            (focusin)="onDensityGuideHover(sample.class)"
            (focusout)="onDensityGuideHover(null)"
            tabindex="0"
          >
            <span class="breast-density-guide__card-badge">{{ sample.class }}</span>
            <h4 class="breast-density-guide__card-title">{{ sample.title }}</h4>
            <p class="breast-density-guide__card-text">{{ sample.description }}</p>
          </article>
        </div>

        <div class="breast-density-guide__footer">
          <svg class="breast-density-guide__footer-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 8v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="12" cy="16" r="1" fill="currentColor"/>
          </svg>
          <div>
            <p class="breast-density-guide__footer-text">
              <strong>Density labels A–D follow the ACR BI-RADS Atlas breast composition categories.</strong>
            </p>
            <p class="breast-density-guide__citation">
              Citation: American College of Radiology. ACR BI-RADS Atlas: Breast Imaging Reporting and Data System. 5th ed. Reston, VA: American College of Radiology; 2013.
            </p>
            <a
              class="breast-density-guide__link"
              [href]="acrBiRadsUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              ACR BI-RADS reference
            </a>
          </div>
        </div>
      </div>
      </div>
    </div>
  </app-modal>
</div>
